import React,  { FunctionComponent, Component } from 'react';
import { Grid, Row, Column, Heading, cls } from '../../../packages/components';
import './_styles.scss';

import { LOAD_REGISTER_IP_TELMEX } from '../../utils/constants';

interface ILoadRegisterLabelsProps {
  /**
   * first image to show header.
   */
  firstImage?: string;
  /**
   * * second image load type.
   */
  secondImage?: string;
  /**
   * * first text  show welcome.
   */
  firstText?: string;
  /**
   * * second text to show message
   */
  secondText?: string;
}

export const LoadRegisterLabels: FunctionComponent<ILoadRegisterLabelsProps> = props => {
  const { firstImage, firstText, secondText} = props;
  return (
    <Grid>
      <Row>
        <Column lg={12} className={cls(`${LOAD_REGISTER_IP_TELMEX}-logo`, `${LOAD_REGISTER_IP_TELMEX}-content-center`)}>
          <img src={firstImage} alt="ClaroVideo logo" />
        </Column>
      </Row>
      <Row>
        <Column lg={12} className={cls(`${LOAD_REGISTER_IP_TELMEX}-second-image`, `${LOAD_REGISTER_IP_TELMEX}-content-center`)}>
          <div className={cls(`${LOAD_REGISTER_IP_TELMEX}-loader`)} />
        </Column>
      </Row>
      <Row>
        <Column lg={12} className={cls(`${LOAD_REGISTER_IP_TELMEX}-content-center`)}>
          <Heading size={1} className={cls(`${LOAD_REGISTER_IP_TELMEX}-first-text`)}>
            {firstText}
          </Heading>
        </Column>
      </Row>
      <Row>
        <Column lg={12} className={cls(`${LOAD_REGISTER_IP_TELMEX}-content-center`)}>
          <Heading size={1} className={cls(`${LOAD_REGISTER_IP_TELMEX}-second-text`)}>
            {secondText}
          </Heading>
        </Column>
      </Row>
    </Grid>
  );
};




// WEBPACK FOOTER //
// ./src/authentication/components/LoadRegisterIPtelmex/index.tsx